import { render } from "./OfficerTable.vue?vue&type=template&id=18c618e8&scoped=true"
import script from "./OfficerTable.vue?vue&type=script&lang=js"
export * from "./OfficerTable.vue?vue&type=script&lang=js"

import "./OfficerTable.vue?vue&type=style&index=0&id=18c618e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c618e8"]])

export default __exports__